import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import { makeTransition } from 'shared/lib/utils/utils';

export default function Divider({
  dividerHeight,
  dividerColor,
  sx,
}: {
  sx?: SxProps;
  dividerHeight: string;
  dividerColor: string;
}) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 0,
        height: dividerHeight,
        borderColor: dividerColor
          ? dividerColor
          : theme.palette.custom.lightGrey,
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        minHeight: '1px',
        flexShrink: 0,
        transition: makeTransition(['border-color']),
        ...sx,
      }}
    ></Box>
  );
}
